import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { BasicService } from '../../providers/basic';
import { TranslateService } from '@ngx-translate/core';
import { environment as config } from '../../../environments/environment';
import { find, propEq, pickBy, mergeDeepRight, pick } from 'ramda';
import { mergeMap } from 'rxjs/operators';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';

@Injectable()
export class LiveeFilesService extends BasicService {
  private TAGS_API = config.tags.url;

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }

  public findAll(
    session: ISession,
    sessionId: string | null = null,
    folderId: string | null = null
  ) {
    return this.http
      .get(`${this.TAGS_API}/tags/${session.id}/file`, {
        headers: this.apiTokenHeaders(),
        search: pickBy(val => !!val, { sessionId, folderId })
      })
      .map(res => this.extractData(res, false));
  }

  public uploadFileForAlias(session: ISession, filename: string, alias: string, data) {
    return this.findAll(session, session.id).pipe(
      mergeMap(files => {
        const value = pick(
          ['id', 'name', 'display', 'alias'],
          mergeDeepRight(find(propEq('alias', alias), files) || {}, {
            name: `${session.id}-${alias}-${filename}`,
            display: `${filename}`,
            alias
          })
        );
        return this.uploadFile(session, value, data);
      })
    );
  }

  public uploadFile(session: ISession, value, data) {
    return this.http
      .put(
        `${this.TAGS_API}/tags/${session.id}/file`,
        {
          value,
          data
        },
        { headers: this.apiTokenHeaders() }
      )
      .map(res => this.extractData(res, false));
  }

  private apiTokenHeaders(): Headers {
    const headers = new Headers();
    headers.append('X-Api-Token', AuthService.retrieve(AuthService.API_TOKEN_KEY));
    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/livee.files.service.ts